import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FilterBar = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedComplexity, setSelectedComplexity] = useState('All');

  const categories = [
    'All', 'Communication', 'Knowledge', 'CRM', 'HRIS', 'Engineering', 
    'Documents', 'ATS', 'Tools', 'SSO'
  ];

  const complexityLevels = ['All', 'Simple', 'Moderate', 'Advanced'];

  return (
    <section className="py-8 bg-gradient-to-b from-[#0B1220] to-[#0F0F11] border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6">
        {/* Hero */}
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Enterprise Integration <span className="text-[#FFD100]">Marketplace</span>
          </h1>
          <p className="text-lg text-white/70 max-w-2xl mx-auto">
            Connect First On Date with 50+ enterprise tools. One-click setups, custom APIs, and white-label options.
          </p>
        </div>

        {/* Search Bar */}
        <div className="mb-6">
          <div className="relative max-w-2xl mx-auto">
            <Icon
              name="Search"
              size={20}
              color="rgba(255,255,255,0.4)"
              className="absolute left-4 top-1/2 transform -translate-y-1/2"
            />
            <input
              type="text"
              placeholder="Search integrations (e.g., Slack, Salesforce, GitHub...)"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              className="w-full bg-white/5 border border-white/20 rounded-2xl pl-12 pr-4 py-4 text-white placeholder-white/40 focus:bg-white/10 focus:border-[#FFD100]/40 focus:outline-none transition-all duration-300"
            />
          </div>
        </div>

        {/* Filters */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Category Filter */}
          <div>
            <label className="block text-white/60 text-sm font-semibold mb-2">CATEGORY</label>
            <div className="flex flex-wrap gap-2">
              {categories?.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                    selectedCategory === category
                      ? 'bg-[#FFD100] text-[#0B1220]'
                      : 'bg-white/5 text-white/70 hover:bg-white/10 border border-white/10'
                  }`}>
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Complexity Filter */}
          <div>
            <label className="block text-white/60 text-sm font-semibold mb-2">SETUP COMPLEXITY</label>
            <div className="flex flex-wrap gap-2">
              {complexityLevels?.map((level) => (
                <button
                  key={level}
                  onClick={() => setSelectedComplexity(level)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                    selectedComplexity === level
                      ? 'bg-[#FFD100] text-[#0B1220]'
                      : 'bg-white/5 text-white/70 hover:bg-white/10 border border-white/10'
                  }`}>
                  {level}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FilterBar;